<template>
    <div class="flex gap-1 items-center">
        <CurrentCoin :name="name.replace(prefixIsUsdtRegxp, '')" />
        {{ name.replace(prefixIsUsdtRegxp, '').toUpperCase() }}
    </div>
</template>

<script setup lang="ts">
import { prefixIsUsdtRegxp } from '~/utils/regxp';


const props = defineProps({
    name: {
        type: String,
        default: '',
        required: true
    },
})

</script>